/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaSelectOneOptionMultiInput/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaCheck from 'DesignSystem/Svgs/TysiaCheck/index'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TysiaSelectOneOptionMultiInput({
  children,
  viewPath = "/DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/TysiaSelectOneOption/TysiaSelectOneOptionMulti/TysiaSelectOneOptionMultiInput",
  backgroundColor,
  value,
  hovered,
  disabled,
  invalid,
  size
  
}) {
let dtTysiacheckboxinputBackgroundcolorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaCheckboxInput.backgroundColor.primary.base'
        })
let dtTysiacheckboxinputBordercolorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaCheckboxInput.borderColor.primary.base'
        })
let dtTysiacheckboxinputBackgroundcolorPrimaryValue = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaCheckboxInput.backgroundColor.primary.value'
        })
let dtTysiacheckboxinputBordercolorPrimaryValue = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaCheckboxInput.borderColor.primary.value'
        })
let dtTysiacheckboxinputBordercolorPrimaryHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaCheckboxInput.borderColor.primary.hovered'
        })
let dtTysiacheckboxinputBackgroundcolorPrimaryInvalid = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaCheckboxInput.backgroundColor.primary.invalid'
        })
let dtTysiacheckboxinputBordercolorPrimaryInvalid = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaCheckboxInput.borderColor.primary.invalid'
        })
let backgroundColorOrdtTysiacheckboxinputBackgroundcolorPrimaryBase = backgroundColor ?? dtTysiacheckboxinputBackgroundcolorPrimaryBase
let dtTysiacheckboxinputFill2PrimaryValue = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaCheckboxInput.fill2.primary.value'
        })
  return (<React.Fragment
>
<div
  data-testid="TysiaSelectOneOptionMultiInput.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-Z2lRweU': value ? dtTysiacheckboxinputBackgroundcolorPrimaryValue : invalid ? dtTysiacheckboxinputBackgroundcolorPrimaryInvalid : backgroundColorOrdtTysiacheckboxinputBackgroundcolorPrimaryBase,'--bc-2-Z2lRweU': value ? dtTysiacheckboxinputBordercolorPrimaryValue : hovered ? dtTysiacheckboxinputBordercolorPrimaryHovered : invalid ? dtTysiacheckboxinputBordercolorPrimaryInvalid : dtTysiacheckboxinputBordercolorPrimaryBase,'--o-5-Z2lRweU': disabled ? 0.25 : 1,'--w-3-Z2lRweU': size === 'small' ? "14px" : "20px",'--h-4-Z2lRweU': size === 'small' ? "14px" : "20px"}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaCheck
  viewPath={`${viewPath}/TysiaCheck`}
 width={16}
 height={16}
 opacity={value ? 1 : 0}
 fill2={dtTysiacheckboxinputFill2PrimaryValue}
/>
</div>
{children}
</React.Fragment>)
}